import React from "react";
import { Link } from "react-router-dom";

//styles
import { ImgRr, NoAlarmContainer, NoAlarmImg } from "./RR.elements";
import { ContainerDiv } from "./RR.elements";
//images
import rrNew from "../../img/numeric/rr/rr.png";
import noAlarmIcon from "../../img/icons/noalarm.png";
import rrBlank from "../../img/numeric/rr/RRBlank.png";
import noAlarmIcon2 from "../../img/icons/noalarm2.jpg";

import rrDefault2 from "../../img/numeric/rr/RR_noarlarm.png";

const RR = ({ landscape }) => {
  return (
    <Link to="/settings/resp" style={{ position: "relative" }}>
      <ImgRr src={rrDefault2} />

      {/* <ImgRr src={rrBlank} /> */}

      {/* <div
        style={{
          position: "absolute",
          bottom: "13%",
          left: "4%",
          background: "black",
          width: "55px",
          paddingTop: "1em",
        }}
      >
        <img
          src={noAlarmICon}
          style={
            {
              // width:"60px"
            }
          }
        />
      </div> */}

      {/* <img
        src={noAlarmICon}
        style={{
          position: "absolute",
          maxHeight: "20px",
          right: "29%",
          top:"60%"
        }}
      /> */}

      {/* <ContainerDiv landscape={landscape}>
        <img src={noAlarmIcon2} alt="" />
      </ContainerDiv> */}
    </Link>
  );
};

export default RR;
